import CreateCartSlice from "../utils/common/CreateCartSlice";

// Create the slice for the Chef cart
const cheffCartSlice = CreateCartSlice("cheffCart");

// Export actions (ensure these are generated correctly by CreateCartSlice)
export const {
  setUserRefCode: setCheffUserRefCode,
  addItemToCart: addCheffItemToCart,
  removeItemFromCart: removeCheffItemFromCart,
  increaseItemQuantity: increaseCheffItemQuantity,
  decreaseItemQuantity: decreaseCheffItemQuantity,
  updateItemQuantity: updateCheffItemQuantity,
  clearCart: clearCheffCart,
} = cheffCartSlice.actions;

// Export the reducer
export default cheffCartSlice.reducer;
